import Link from '@gik/core/components/Link.tsx';
import type { WordpressTaxonomy } from '@gik/core/models/wordpress/WordpressTaxonomy';
import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Badge } from '@gik/ui-legacy/Badge';
import { HTMLParser } from '@gik/ui-legacy/HTMLParser';
import { Image } from '@gik/ui-legacy/Image';
import { ButtonBone } from '@gik/ui-legacy/SkeletonLoader';
import type React from 'react';

export type TaxonomyListProps = {
  items?: WordpressTaxonomy[];
  skeletonItems?: number;
  selected?: string;
} & UIComponent;

function TaxonomyListComp({ items, selected }: TaxonomyListProps): React.ReactElement {
  const bem = useBemCN('taxonomy-list');
  const situationsSorted = items;

  return (
    <div {...bem()}>
      {situationsSorted?.map(item => {
        const parentItem = items.find(p => p.id === item.parent);

        let url = `/situation/${item.slug}`;

        if (parentItem) {
          url = `/situation/${parentItem.slug}/${item.slug}`;
        }

        return (
          <Link key={item.id} href={url} scroll>
            <Badge pill variant="default-light" key={item.id} {...bem('item', [{ selected: item.slug === selected }])}>
              <Image src={item.acf.taxonomy_svg_icon} />
              <HTMLParser rawHtml={item.name} />
            </Badge>
          </Link>
        );
      })}
    </div>
  );
}

export const TaxonomyList = withComponentErrorBoundary(TaxonomyListComp);

export const TaxonomyListSkeleton = ({ skeletonItems = 40 }: Partial<TaxonomyListProps>): React.ReactElement => {
  const bem = useBemCN(`taxonomy-list`);

  return (
    <div {...bem()}>
      {Array.from(Array(skeletonItems).keys()).map(index => {
        return <ButtonBone pill key={index} />;
      })}
    </div>
  );
};
